import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import WorkerCard from '../components/WorkerCard';
import apiClient from '../api/api';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function SearchResultsPage() {
  const query = useQuery();
  const searchTerm = query.get('q');
  const [workers, setWorkers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!searchTerm) return;

    const fetchResults = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await apiClient.get(`/workers?q=${encodeURIComponent(searchTerm)}`);
        setWorkers(response.data.workers);
      } catch (err) {
        console.error(`Error fetching search results for "${searchTerm}":`, err);
        setError('Failed to load search results.');
      } finally {
        setLoading(false);
      }
    };

    fetchResults();
  }, [searchTerm]);

  const renderContent = () => {
    if (loading) {
      return <p className="text-center col-span-full">Searching...</p>;
    }
    if (error) {
      return <p className="text-center col-span-full text-red-500">{error}</p>;
    }
    if (workers.length === 0) {
      return <p className="text-center col-span-full">No workers found for your search.</p>;
    }
    return (
      workers.map(worker => (
        <WorkerCard key={worker.id} worker={worker} />
      ))
    );
  }

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-xl md:text-2xl font-bold mb-4">Search Results for "{searchTerm}"</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {renderContent()}
      </div>
    </div>
  );
}

export default SearchResultsPage;